module.exports = __webpack_public_path__ + "static/img/boshi.1d01556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/boshi.jpg
// module id = AsPP
// module chunks = 0